export default "__VITE_ASSET__BmMTF6Dh__"